import React from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Grid, Divider } from '@mui/material';
import { grey } from '@mui/material/colors';

function OfferingGeneralInfo({ product }) {
  // Use product.related_data.product.fields if available, otherwise use demo data
  const productFields = product?.related_data?.product?.fields || {
    'Product Name': product?.name || 'N/A',
    Description: 'This is a sample description for the offering. You can add more details here.',
    'Product Family': 'Software',
    'Lifecycle Status': 'Active',
    'Billing Frequency': 'Monthly',
    'Pricing Model': 'Subscription',
    // Add more demo fields as needed
  };

  return (
    <Card>
      <ArgonBox p={3}>
        <ArgonBox>
          {Object.entries(productFields).map(([key, value]) => (
            <ArgonBox key={key} mb={1} width="100%">
              <Grid container alignItems="center" spacing={0}>
                <Grid item xs={7}>
                  <ArgonTypography
                    variant="caption"
                    color="textSecondary"
                    align="left"
                    sx={{ wordWrap: 'break-word', color: grey[700] }}
                    ml={3}
                    fontSize={13}
                    fontWeight="medium"
                  >
                    {key}
                  </ArgonTypography>
                </Grid>
                <Grid item xs={1} style={{ textAlign: 'center' }}>
                  <Divider orientation="vertical" flexItem />
                </Grid>
                <Grid item xs={3} style={{ textAlign: 'center' }}>
                  <ArgonBox
                    bgcolor={grey[200]}
                    color={grey[700]}
                    p={1}
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ width: '100%', boxSizing: 'border-box' }}
                  >
                    <ArgonTypography variant="caption" fontWeight="bold" sx={{ wordWrap: 'break-word', width: '100%' }}>
                      {value || '-'}
                    </ArgonTypography>
                  </ArgonBox>
                </Grid>
              </Grid>
            </ArgonBox>
          ))}
        </ArgonBox>
      </ArgonBox>
    </Card>
  );
}

export default OfferingGeneralInfo;
